import AnchorButton from 'components/AnchorButton';
import AppealDescriptionBps from 'content/category-content/business-phone-systems/appeal-description.md';
import Header from 'components/Header';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  AnchorButton,
  AppealDescriptionBps,
  Header,
  React,
  MDXTag
};